import { Claim, ClaimVehicleRepair, Occupant, ThirdPartyDetail, VehicleHire } from '../../models/claim.model';
import { SummaryCardComponent } from "../ui-components/summary-card/summary-card.component";
import { MinsterCardComponent } from '../ui-components/minster-card/minster-card.component';
import { DateFormatPipe, TimeFormatPipe } from '../pipes/date-time-format.pipe';
import { Customer, CustomerContactDetail } from '../../models/customer.model';
import { ScreenValidation } from '../../models/screen-validation.model';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { StateService } from '../../services/state.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { ScreenType } from '../../models/enums.models';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-submit',
    standalone: true,
    imports: [MinsterCardComponent, MatCheckboxModule, MatIconModule, MatButtonModule, MatCardModule,
        TimeFormatPipe, MatExpansionModule, SummaryCardComponent, DateFormatPipe],
    templateUrl: './submit.component.html',
    styleUrl: './submit.component.css'
})

export class SubmitComponent {
    @Input('screenValidation') _screenValidation: ScreenValidation | undefined;

    _claim: Claim;
    _screen = ScreenType;
    _customer: Customer;
    _contactDetails: CustomerContactDetail;
    _vehicleRepair: ClaimVehicleRepair;
    _thirdParty: ThirdPartyDetail;
    _haveWitnesses: boolean;
    _driver: Occupant;
    _vehicleHire: VehicleHire;

    constructor(private stateService: StateService) {
        this._claim = stateService.claim!;
        this._customer = stateService.customer!;
        this._contactDetails = stateService.customer!.customerContactDetails[0];
        this._vehicleRepair = stateService.claim!.claimVehicle.claimVehicleRepairs![0];
        this._thirdParty = stateService.claim!.thirdPartyDetails.find(x => x.isPrimary)!;
        this._haveWitnesses = stateService.claim!.witnesses.length > 0;
        this._driver = this._claim.occupants.find(c => c.isDriver)!;
        this._vehicleHire = stateService.claim!.claimVehicle.vehicleHires![0];
    }

    get employmentStatus(): string {
        return this.stateService.getLooUpValue('OccupationStatus', this._claim!.claimant.occupationStatusId);
    }

    get isSeatBeltWorn(): string {
        return this.stateService.getLooUpValue('SeatBeltIsWorn', this._claim!.accident.isSeatbeltWornId);
    }

    get injuryAnyOtherTreatment(): string {
        return this.stateService.getLooUpValue('DoctorRecommendsFurtherTreatment', this._claim!.injury.doctorRecommendsFurtherTreatmentId);
    }

    get medicalProfessional(): string {
        return this.stateService.getLooUpValue('MedicalAttentionSought', this._claim!.injury.medicalAttentionSoughtId);
    }

    get selectedPoliceInvolvement(): string {
        return this.stateService.getLooUpValue('PoliceInvolvement', this._claim.policeInvolvementId);
    }

    get obtainedThirdPartyDetails(): string {
        return this.stateService.getLooUpValue('ObtainedThirdPartyDetail', this._thirdParty.obtainedThirdPartyDetailId);
    }

    get accidentCountry(): string {
        return this.stateService.getLooUpValue('AccidentCountryDigitalOnBoarding', this._claim.accident.accidentCountryId);
    }

    get productType(): string {
        return this.stateService.getLooUpValue('ProductType', this._claim.productTypeId);
    }

    get claimantType(): string {
        return this.stateService.getLooUpValue('ClaimantType', this._claim.claimant.claimantTypeId);
    }

    get accidentSummary(): string {
        return this.stateService.getLooUpValue('AccidentSummaryDigitalOnBoarding', this._claim.accident.summaryId);
    }

    get vehicleSpeed(): string {
        return this.stateService.getLooUpValue('VehicleSpeed', this._claim.accident.claimantVehicleSpeedId);
    }

    get repairHelpRequiredReason(): string {
        return this.stateService.getLooUpValue('RepairHelpNotRequiredReasonsDigtialOnBoarding', this._vehicleRepair.repairHelpNotRequiredReasonId);
    }

    get whyHireNotNeeded(): string {
        return this.stateService.getLooUpValue('WhyHireNotNeededDigitalOnBoarding', this._vehicleHire.whyHireNotNeededId);
    }
    
    get policeJuridiction(): string {
        return this.stateService.getLooUpValue('PoliceJurisdiction', this._claim.police.policeJurisdictionId);
    }

    get showCompanyName(): boolean {
        return this._vehicleHire.whyHireNotNeededId === 6;
    }

    get niNumber(): string {
        if (this._claim!.claimant.noNationalInsuranceNumberReasonId !== 1 && this._claim!.claimant.noNationalInsuranceNumberReasonId !== 2) {
            return this._claim!.claimant.nationalInsuranceNumber;
        } 
        else {
            return this.stateService.getLooUpValue('NationalInsuranceReason', this._claim!.claimant.noNationalInsuranceNumberReasonId);
        }
    }

   selectTitle(type: string, index?: number): string {
    let titleId: number | undefined;
    
    if (type === 'client') {
        titleId = this._customer.titleId;
    } 
    else if (type === 'passenger') {
        titleId = this.passengers[index ?? 0]?.titleId;
    }
    else if (type === 'witness') {
        titleId = this._claim.witnesses[index ?? 0]?.titleId;
    }

    if (!titleId) {
        return '';
    }

    return this.stateService.getLooUpValue('Title', titleId) || ''; 
}

    selectedAreaOfBody(index: number): string {
        const areaOfBodyId = this._claim.injury.injuryDetails[index]?.areaOfBodyId;
        return this.stateService.getLooUpValue('AreaOfBody', areaOfBodyId);
    }

    selectedBodyPart(index: number): string {
        const bodyPartId = this._claim.injury.injuryDetails[index]?.bodyPartId;
        return this.stateService.getLooUpValue('BodyPart', bodyPartId);
    }

    selectedInjuryType(index: number): string {
        const injuryTypeId = this._claim.injury.injuryDetails[index]?.injuryTypeId;
        return this.stateService.getLooUpValue('InjuryType', injuryTypeId);
    }

    getSufferedInjury(index: number): string {
        const passengerInjuryId = this.passengers[index]?.passengerInjuryStatusId!;
        return this.stateService.getLooUpValue('PassengerInjuryStatus', passengerInjuryId);
    }

    get hospitalName(): string {
        const injuryHospitals = this._claim?.injury?.injuryHospitals;
        if (!injuryHospitals || injuryHospitals.length === 0) {
            return '';
        }

        const hospitalId = injuryHospitals[0].hospitalId;
        if (!hospitalId) {
            return '';
        }

        const hospital = this.stateService.lookUps?.hospitals?.find(x => x.hospitalId === hospitalId);
        return hospital?.description ?? '';
    }

    get hospitalNights(): number {
        return this._claim.injury.injuryHospitals[0]?.nightsDetained || 0;
    }

    get isEmployed(): boolean {
        return this._claim.claimant.occupationStatusId == 1 || this._claim.claimant.occupationStatusId == 2
    }

    get isOccupationVisible(): boolean {
        return (this._claim.claimant.occupationStatusId == 1 ||
            this._claim.claimant.occupationStatusId == 2 ||
            this._claim.claimant.occupationStatusId == 6 ||
            this._claim.claimant.occupationStatusId == 7 ||
            this._claim.claimant.occupationStatusId == 8);
    }

    get isBusCarVanLorryPassenger(): boolean {
        return this._claim.claimant.claimantTypeId === 9 || this._claim.claimant.claimantTypeId === 8;
    }

    get isDriver(): boolean {
        return this._claim.claimant.claimantTypeId === 2;
    }

    get isPassenger(): boolean {
        return this._claim.claimant.claimantTypeId === 8 || this._claim.claimant.claimantTypeId === 9;
    }

    get policeInvolved(): boolean {
        return this._claim.policeInvolvementId == 0 || this._claim.policeInvolvementId == 2
    }

    get otherVehicles(): ThirdPartyDetail[] {
        return this._claim!.thirdPartyDetails.filter(x => x.isPrimary == false);
    }

    get isVehicleOwner(): boolean {
        return this.stateService.claim?.isVehicleOwner || false;
    }

    get additionalTpInvolved(): boolean{
        return this._claim.thirdPartyDetails.filter(x => x.isPrimary == false)?.length > 0;
    }

    get passengers(): Occupant[] {
       return this.stateService.claim?.occupants?.filter(x => x.isDriver === false) || [];
    }

    get additionalThirdParties(): ThirdPartyDetail[] {
       return this.stateService.claim!.thirdPartyDetails.filter(x => x.isPrimary === false) || [];
    }

    get thirdPartyInsuranceKnown(): boolean{
        return this.stateService.claim?.isThirdPartyInsuranceKnown || false;
    }
}
